import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    // Simulating a request to reset the password
    setTimeout(() => {
      // Perform any necessary password reset actions

      setLoading(false);
      setSubmitted(true);
    }, 1500);
  };

  return (
    <Container>
           <Row className="vh-80 d-flex justify-content-center align-items-center my-4">
        <Col xs={12} sm={8} md={6} lg={4}>
        <div className="border border-3 border-primary"></div>
            <Card className="shadow">
            <Card.Body>
              
              <div className="mb-3 mt-md-4">
                  <h3 className="fw-bold mb-2 text-center">Forgot Password</h3>
                
                  <div className="mb-3">
              {submitted ? (
                <div className="text-center">
                  <p>Instructions to reset your password have been sent to your email.</p>
                  <p>It might take few minutes. Please check your inbox. </p>
                </div>
              ) : (
                <>
                  <p className="mb-2 text-center">Please enter your email to reset password.</p>
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter email"
                      value={email}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Button variant="primary" type="submit" className="w-100" disabled={loading}>
                    {loading ? 'Loading...' : 'Reset Password'}
                  </Button>
                </Form>
                <div className="mt-3">
                      <p className="mb-0 text-center">
                      <a href="/login" className="text-primary fw-bold">
                          Log In
                        </a>{' '} or {' '}
                        <a href="/signup" className="text-primary fw-bold">
                          Sign Up
                        </a>
                      </p>
                    </div>
                </>
              )}
              </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
